import React from 'react';
import './../css/loader.css';

function Loader() {
  return (
    <div className="d-flex justify-content-center">
      <div className="loader">
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

export default Loader;
